const Utils = {};

Utils.elementPosition = () => {
	let elements = ['four-services', 'product-line', 'company-news', 'job-dynamics', 'strategic-partners',
		'about-us'];
	for(let i = 0, length = elements.length; i < length; i++) {
		let ele = document.getElementsByClassName(elements[i])[0];
		if (ele) {
			let top = ele.getBoundingClientRect().top;
			if(top > 0 ) {
				return elements[i]
			}
		}
	}
	return 'about-us'
};
export default Utils;
